import { useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "../core/auth-context";

const Header = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);

  const handleLogout = async () => {
    await logout();
    navigate("/", { replace: true });
  };

  const navLinkClass = ({ isActive }: { isActive: boolean }) =>
    `px-3 py-2 text-sm tracking-wide transition-colors ${
      isActive
        ? "text-white"
        : "text-ink-300 hover:text-white"
    }`;

  return (
    <header className="sticky top-0 z-30 backdrop-blur bg-ink-950/70 border-b border-ink-700">
      <div className="max-w-6xl mx-auto px-6 h-16 flex items-center justify-between">
        <Link
          to="/"
          className="flex items-center space-x-2 group"
          onClick={() => setMenuOpen(false)}
        >
          <span
            aria-hidden
            className="w-2 h-2 rounded-full bg-accent-500 shadow-glow group-hover:scale-110 transition-transform"
          />
          <span className="font-display text-xl text-white tracking-wide">
            A Dark Place
          </span>
        </Link>

        <nav className="hidden md:flex items-center space-x-1">
          <NavLink to="/" end className={navLinkClass}>
            Stories
          </NavLink>
          <NavLink to="/submit" className={navLinkClass}>
            Submit
          </NavLink>

          <div className="ml-3 pl-3 border-l border-ink-700 flex items-center space-x-2">
            {user ? (
              <>
                <span className="text-xs text-ink-300 hidden lg:inline">
                  {user.displayName || user.email}
                </span>
                <button
                  onClick={handleLogout}
                  className="text-sm px-3 py-1.5 rounded-md bg-ink-700 hover:bg-ink-600 text-white"
                >
                  Sign out
                </button>
              </>
            ) : (
              <>
                <Link
                  to="/login"
                  className="text-sm text-ink-200 hover:text-white px-3 py-1.5"
                >
                  Sign in
                </Link>
                <Link
                  to="/register"
                  className="text-sm px-3 py-1.5 rounded-md bg-accent-500 hover:bg-accent-400 text-white"
                >
                  Register
                </Link>
              </>
            )}
          </div>
        </nav>

        <button
          aria-label="Toggle menu"
          className="md:hidden text-ink-200 hover:text-white"
          onClick={() => setMenuOpen((o) => !o)}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="22"
            height="22"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            {menuOpen ? (
              <>
                <line x1="18" y1="6" x2="6" y2="18" />
                <line x1="6" y1="6" x2="18" y2="18" />
              </>
            ) : (
              <>
                <line x1="3" y1="12" x2="21" y2="12" />
                <line x1="3" y1="6" x2="21" y2="6" />
                <line x1="3" y1="18" x2="21" y2="18" />
              </>
            )}
          </svg>
        </button>
      </div>

      {menuOpen && (
        <div className="md:hidden border-t border-ink-700 bg-ink-900">
          <div className="px-6 py-3 flex flex-col space-y-1">
            <NavLink
              to="/"
              end
              className={navLinkClass}
              onClick={() => setMenuOpen(false)}
            >
              Stories
            </NavLink>
            <NavLink
              to="/submit"
              className={navLinkClass}
              onClick={() => setMenuOpen(false)}
            >
              Submit
            </NavLink>
            <div className="pt-2 border-t border-ink-700 mt-2 flex items-center space-x-2">
              {user ? (
                <button
                  onClick={() => {
                    setMenuOpen(false);
                    handleLogout();
                  }}
                  className="text-sm px-3 py-1.5 rounded-md bg-ink-700 hover:bg-ink-600 text-white"
                >
                  Sign out
                </button>
              ) : (
                <>
                  <Link
                    to="/login"
                    onClick={() => setMenuOpen(false)}
                    className="text-sm text-ink-200 hover:text-white px-3 py-1.5"
                  >
                    Sign in
                  </Link>
                  <Link
                    to="/register"
                    onClick={() => setMenuOpen(false)}
                    className="text-sm px-3 py-1.5 rounded-md bg-accent-500 hover:bg-accent-400 text-white"
                  >
                    Register
                  </Link>
                </>
              )}
            </div>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
